import {useMutation} from '@apollo/client/react';
import {extractGqlData} from '@coolcolduk/ui-apollo-client';
import {Question, QuestionCheckInput} from '@cp/model';
import {CHECK_QUESTION_WITH_GPT_DIRECT} from '../sharedQueries';

export function useCheckQuestionWithGptDirect() {
  const [checkQuestionWithGptDirectMutation, {loading, error}] = useMutation<
    {checkQuestionWithGptDirect: Question},
    {questionInput: QuestionCheckInput; audienceLevel: string}
  >(CHECK_QUESTION_WITH_GPT_DIRECT);

  /**
   * Check a question input using GPT validation directly (Admin only)
   * @param questionInput - The question input to validate
   * @param audienceLevel - The audience level (e.g., "GCSE Maths Foundation")
   * @returns Question with updated status and statusNote if validation fails
   */
  const checkQuestionWithGptDirect = async (questionInput: QuestionCheckInput, audienceLevel: string) => {
    const result = await checkQuestionWithGptDirectMutation({
      variables: {questionInput, audienceLevel},
    });

    return extractGqlData(result).checkQuestionWithGptDirect;
  };

  return {
    checkQuestionWithGptDirect,
    loading,
    error,
  };
}
